
import { freeTemplateList, sceneConfig } from '~/api/library-center/common.js'
export default {
  name: 'ScrouselTabs',
  model: {
    prop: 'active',
  },
  props: {
    title: {
      type: String,
      default: '免费经典模板',
    },
    // 轮播图数字
    dataList: {
      type: Array,
      default: null,
    },
    // 页签数据
    tablist: {
      type: Array,
      default: null,
    },
    // 采用tablist中的某个属性值作为轮播的数据
    useTabData: {
      type: String,
      default: '',
    },
    // 移动端
    isMobile: {
      type: Boolean,
      default: null,
    },
    // 使用方向按键
    useDirection: {
      type: Boolean,
      default: false,
    },
    // 容器背景色
    background: {
      type: String,
      default: null,
    },
    // 容器高度
    height: {
      type: String,
      default: null,
    },
    active: {
      type: String,
      default: '',
    },
    // 场景选择 1=>问卷调研, 2=> 满意度
    scene: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      curActive: 0, // 页签索引
      moveIndex: 0, // 滚动索引
      data: [],
      tabs: [],
    }
  },
  fetchOnServer: false,
  async fetch() {
    await this.init()
  },
  computed: {
    curMobile() {
      return this.$store.state.isMobile
    },
    isHandset() {
      return this.$store.state.isHandset
    },
    isPad() {
      return this.$store.state.isPad
    },
  },
  watch: {
    active: {
      handler(cval) {
        this.curActive = cval
      },
      immediate: true,
    },
  },
  methods: {
    async init() {
      try {
        const {
          data: {
            query_label: queryLabel,
            query_label: [firstItem = {}],
          },
        } = await sceneConfig(this.scene)
        this.tabs = queryLabel
        await this.getData(firstItem.label)
        return Promise.resolve()
      } catch (e) {
        console.log(e)
      }
    },
    async getData(queryLabel) {
      const { data } = await freeTemplateList({
        label: queryLabel,
        scene: this.scene,
      })
      this.data = []
      this.$nextTick(() => (this.data = data.lib_list))
    },
    // 滚动卡片
    moveItem(direction) {
      const card = this.$refs['carousel-step']
      card.moving(direction)
    },
    // 切换页签
    tagsClick(name, title) {
      this.$emit('input', name)
      this.$emit('click', name, title)
      this.getData(name)
      this.reset()
    },
    // 重置
    reset() {
      const card = this.$refs['carousel-step']
      card.reset()
    },
    // 点击中间的卡片
    clickItem(item, ii, field, i) {
      this.$emit('clickItem', item, ii, field, i)
    },
  },
}
